import { StorageDurationEnum } from '@shared/api/types';
import { SelectOption } from '@shared/components/form/select-form-field';

export const storageDurationOptions: SelectOption[] = [
  {
    label: 'Not stored',
    value: StorageDurationEnum['not_stored'],
  },
  {
    label: 'Stored half a day',
    value: StorageDurationEnum['stored_half_day'],
  },
  {
    label: 'Stored 1 day',
    value: StorageDurationEnum['stored_1_day'],
  },
  {
    label: 'Stored 2 days',
    value: StorageDurationEnum['stored_2_days'],
  },
  {
    label: 'Stored 3 days',
    value: StorageDurationEnum['stored_3_days'],
  },
  {
    label: 'Stored 5 days',
    value: StorageDurationEnum['stored_5_days'],
  },
  {
    label: 'Stored 1 week',
    value: StorageDurationEnum['stored_1_week'],
  },
  {
    label: 'Stored 1.5 weeks',
    value: StorageDurationEnum['stored_1_half_week'],
  },
  {
    label: 'Stored 2 weeks',
    value: StorageDurationEnum['stored_2_weeks'],
  },
  {
    label: 'Stored 3 weeks',
    value: StorageDurationEnum['stored_3_weeks'],
  },
  {
    label: 'Stored 1 month',
    value: StorageDurationEnum['stored_1_month'],
  },
];
